import { supabase } from '../config/supabaseConfig.ts';

// Columnas legibles de `project` por el rol authenticated.
// token y elevenlabs_webhook_secret NO se pueden seleccionar (privilegios de columna):
// usar proyectService.getSecrets (RPC admin_get_project_secrets).
export const PROJECT_COLUMNS = [
  'id', 'name', 'description', 'created_at', 'project_type', 'platform',
  'phone_number_id', 'project_manager_id', 'modules', 'profile_photo', 'kb_table',
  'drive_link', 'query_name', 'last_train', 'suscription', 'price', 'next_payment',
  'status', 'message_teplate', 'google_drive_folder_id', 'image_template',
  'document_template', 'channels', 'waba_id', 'app_id',
].join(', ');

export const proyectService = {
  getAll: async () => {
    try {
      const { data, error } = await supabase
        .from('project')
        .select(`${PROJECT_COLUMNS}, project_types(*), project_manager(*)`);
      
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al obtener proyectos:', error);
      throw error;
    }
  },

  createProyect: async (proyect) => {
    try {
      const { data, error } = await supabase
        .from('project')
        .insert({
          name: proyect.name,
          description: proyect.description,
          project_type: proyect.project_type,
          project_manager_id: proyect.project_manager_id,
          platform: proyect.platform,
          status: proyect.status || 'active',
          modules: proyect.modules,
          channels: proyect.channels || null,
          token: proyect.token || null,
          phone_number_id: proyect.phone_number_id || null,
          kb_table: proyect.kb_table || null,
          drive_link: proyect.drive_link || null,
          query_name: proyect.query_name || null,
          profile_photo: proyect.profile_photo || null,
          google_drive_folder_id: proyect.google_drive_folder_id || null,
          last_train: proyect.last_train || null,
          message_teplate: proyect.message_teplate || null,
          image_template: proyect.image_template || null,
          document_template: proyect.document_template || null,
          suscription: proyect.suscription || null,
          price: proyect.price || null,
          next_payment: proyect.next_payment || null,
        })
        .select(PROJECT_COLUMNS)
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al crear proyecto:', error);
      throw error;
    }
  },

  updateProyect: async (id, proyect) => {
    try {
      const { data, error } = await supabase
        .from('project')
        .update({
          name: proyect.name,
          description: proyect.description,
          project_type: proyect.project_type,
          project_manager_id: proyect.project_manager_id,
          platform: proyect.platform,
          status: proyect.status,
          modules: proyect.modules,
          channels: proyect.channels || null,
          // token undefined = no modificar (no se pudo leer el valor actual)
          ...(proyect.token !== undefined ? { token: proyect.token || null } : {}),
          phone_number_id: proyect.phone_number_id || null,
          kb_table: proyect.kb_table || null,
          drive_link: proyect.drive_link || null,
          query_name: proyect.query_name || null,
          profile_photo: proyect.profile_photo || null,
          google_drive_folder_id: proyect.google_drive_folder_id || null,
          last_train: proyect.last_train || null,
          message_teplate: proyect.message_teplate || null,
          image_template: proyect.image_template || null,
          document_template: proyect.document_template || null,
          suscription: proyect.suscription || null,
          price: proyect.price || null,
          next_payment: proyect.next_payment || null,
        })
        .eq('id', id)
        .select(PROJECT_COLUMNS)
        .single();
      
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al actualizar proyecto:', error);
      throw error;
    }
  },

  // Secretos del proyecto (token, elevenlabs_webhook_secret). Solo funciona para admins.
  getSecrets: async (id) => {
    try {
      const { data, error } = await supabase
        .rpc('admin_get_project_secrets', { p_project_id: id });
      if (error) throw error;
      // RETURNS TABLE → PostgREST devuelve un arreglo
      return Array.isArray(data) ? (data[0] || null) : data;
    } catch (error) {
      console.error('Error al obtener secretos del proyecto:', error);
      throw error;
    }
  },

  deleteProyect: async (id) => {
    try {
      const { data, error } = await supabase
        .from('project')
        .delete()
        .eq('id', id);
      
      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error al eliminar proyecto:', error);
      throw error;
    }
  },

  toggleProyectStatus: async (id, status) => {
    try {
      const { data, error } = await supabase
        .from('project')
        .update({ status: status })
        .eq('id', id)
        .select(PROJECT_COLUMNS)
        .single();
      
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al cambiar el estado del proyecto:', error);
      throw error;
    }
  },
}   